import React, { ReactNode } from 'react';
import { Chit } from 'src/components/ui/chit';

interface StatChitProps {
  value: number | string;
  label: string;
  icon?: ReactNode;
}

export const StatChit: React.FC<StatChitProps> = ({
  value,
  label,
  icon
}) => {
  return (
    <Chit>
      <div className="flex items-center justify-between">
        <div>
          <h3 className="text-white text-2xl font-semibold mb-1">
            {value}
          </h3>
          <p className="text-white/40 text-sm">
            {label}
          </p>
        </div>
        {icon && (
          <div className="text-white/20 text-2xl">
            {icon}
          </div>
        )}
      </div>
    </Chit>
  );
};